import React from 'react';
import styles from './CustomNoRowsTemplate.module.css';
import CheckMarkIcon from '../../../assets/SVGs/checkmark.svg';
const CustomNoRowsTemplate = () => {
    return (
        <div 
            role="presentation" 
            className={`${styles.noRowsDiv} ag-overlay-loading-center`} >
            <div>
                <img src={CheckMarkIcon} alt="All good!" />
            </div>

            <div className={styles.mainTitle}>
                All good!
            </div>
            <div className={styles.secondaryTitle}>
                No anomalies detected at this level for your selection.
            </div>
        </div>
    );
};
export default CustomNoRowsTemplate;